angular.module('impactx.system').controller('SystemDashboardCtrl', [
    '$scope',
    '$http',
    'dataGen',
    '$route',
    SystemDashboardCtrl]);

function SystemDashboardCtrl($scope, $http, dataGen, $route) {

    var ctrl = this;
    $scope.exportingRoutes = false;

    $http.get('version.json').then(function (result) {
        var version = result.data;
        $scope.versionMajor = version.major;
        $scope.versionMinor = version.minor;
        $scope.versionBuildNo = version.buildno;
        if (version.buildDate) {
            $scope.buildDate = new Date(version.buildDate).toLocaleString("de-DE");
        }
    });

    ctrl.exportRoutes = function() {
        $scope.exportingRoutes = true;
        var allRoutes = [];
        for(var key in $route.routes) {
            if ($route.routes.hasOwnProperty(key)) {
                var entry = impactX.routeForHelpService(key);
                if (entry && allRoutes.indexOf(entry) < 0) {
                    allRoutes.push(entry);
                }
            }
        }
        var formParams = {
            routes: {
                routes: allRoutes
            }
        };
        dataGen.postAsForm({}, formParams, "/help/exportroutes").then(function(response) {
            $scope.exportingRoutes = false;
            if(response && response.data) {
                $scope.createdRoutes = response.data.created;
                $scope.ignoredRoutes = response.data.ignored;
                $scope.deletedRoutes = response.data.deleted;
                $scope.exportSuccessful = true;
            }
        }, function () {
            $scope.exportingRoutes = false;
        });
    };

    ctrl.getData = function () {
        dataGen.getData({}, {}, "/systemadministration/dashboard").then(function(result) {
            if(result) {
                $scope.trns = result.trns;
                if(result.data) {
                    $scope.hasHelpService = result.data.hasHelpService;
                    $scope.helpServiceURL = result.data.helpServiceURL;
                    $scope.licenses = result.data.licenses;
                    if($scope.hasHelpService) {
                        dataGen.getData({}, {}, "/systemadministration/checkhelp").then(function (checkResult) {
                            if (checkResult && checkResult.data) {
                                $scope.helpServiceStatus = checkResult.data;
                            }
                            $scope.helpChecked = true;
                        })
                    }
                }
            }
        })
    };
    ctrl.getData();
}